import jquery from "jquery";
import moment from "moment";
import axios from "axios";

// Expose these globally.
export default function bootstrap() {
    window.$ = jquery;
    window.jQuery = jquery;
    window.moment = moment;
    window.axios = axios;
    window.axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";
}
